import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import style from './style.css'

const classnames = require( 'classnames' )
const { JsonEditorDialog } = require( '../../views' )
const { HistoryActions, EventActions } = require( '../../actions' )
const util = require( './util' )

class JsonEditor extends React.Component {

  static TYPE = 'jsonEditor';

  static propTypes = {
    query : PropTypes.object.isRequired,
    queryName : PropTypes.string.isRequired,
    syncWithLocation : PropTypes.func,
    history : PropTypes.object.isRequired,
    location : PropTypes.object.isRequired,
    actions : PropTypes.object.isRequired
  };

  static defaultProps = {
    syncWithLocation : () => {}
  };

  /*
    {
      onYes : PropTypes.func,
      onNo : PropTypes.func,
      title : PropTypes.string,
      message : PropTypes.oneOfType( [ PropTypes.string, PropTypes.element ] ),
      value : PropTypes.object,
      ok : PropTypes.string,
      cancel : PropTypes.string
    }
  */

  constructor( props, context ) {
    super( props, context )
    const { query } = props
    this.state = {
      show : true
    }
    this.syncQueryToLocation( query )
  }

  syncQueryToLocation( query ) {
    const { syncWithLocation } = this.props
    syncWithLocation( query )
  }

  updateQuery( query ) {
    const { queryName, actions, dispatch } = this.props

    dispatch( actions.updateQuery( {
      name : queryName,
      query
    } ) )
    this.syncQueryToLocation( query )
  }

  onOk = ( val ) => {
    this.setState( {
      show : false
    } )

    this.updateQuery( val )
  }

  onCancel = () => {
    this.setState( {
      show : false
    } )
  }

  onOpen = () => {
    this.setState( {
      show : true
    } )
  }

  render() {
    const { query, className } = this.props
    const { show } = this.state
    return (
      <div className={classnames( style.filter, className )}>
        <Button className={style.openJson} onClick={this.onOpen}>
          Open Editor
        </Button>
        <JsonEditorDialog
          show={show}
          onOk={this.onOk}
          onCancel={this.onCancel}
          title="JSON Query Editor"
          message="Edit Raw Query"
          value={query}
          ok="Update Query"
          cancel="Cancel Changes" />
      </div>
    )
  }
}

export default connect( state => ( { } ) )( JsonEditor )
